/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDraftMutationVariables = Types.Exact<{
  configurationId: Types.Scalars['String'];
}>;


export type CreateDraftMutation = { __typename: 'Mutation', createDraftConfiguration: { __typename: 'ConfigurationModel', id: string } };


export const CreateDraftDocument = gql`
    mutation CreateDraft($configurationId: String!) {
  createDraftConfiguration(configurationId: $configurationId) {
    id
  }
}
    `;
export type CreateDraftMutationFn = ApolloReactCommon.MutationFunction<CreateDraftMutation, CreateDraftMutationVariables>;

/**
 * __useCreateDraftMutation__
 *
 * To run a mutation, you first call `useCreateDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftMutation, { data, loading, error }] = useCreateDraftMutation({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *   },
 * });
 */
export function useCreateDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDraftMutation, CreateDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDraftMutation, CreateDraftMutationVariables>(CreateDraftDocument, options);
      }
export type CreateDraftMutationHookResult = ReturnType<typeof useCreateDraftMutation>;
export type CreateDraftMutationResult = ApolloReactCommon.MutationResult<CreateDraftMutation>;
export type CreateDraftMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDraftMutation, CreateDraftMutationVariables>;